module.exports = __webpack_public_path__ + "static/img/ic_file_word.60c0199d.png";